import { StructuredQA } from '../../qa/StructuredQA';
import { QueryExecutor } from '../../qa/QueryExecutor';
import type { IAgentTool } from '../IAgentTool';

export const highlightTool: IAgentTool = {
  name: 'highlight',
  description: 'Highlight nodes that match a query or name.',
  parameters: {
    type: 'object',
    properties: {
      query: { type: 'string', description: 'Query or name to highlight' },
    },
    required: ['query'],
  },
  supportedDiagramTypes: [],
  tier: 'visual',
  category: 'display',

  async execute(params, context) {
    const query = String(params.query ?? '').trim();
    if (!query) return { success: false, summary: 'Missing query to highlight.' };

    if (!context.stores.highlight?.setHighlightedIds) {
      return { success: false, summary: 'Highlight store not available in this view.' };
    }

    const structuredQA = new StructuredQA();
    const parsed = structuredQA.tryParse(query);
    const executor = new QueryExecutor();

    const result = parsed
      ? executor.execute(parsed, {
          nodes: context.diagramData.nodes.map((node) => ({
            id: node.id,
            type: node.type,
            data: { ...(node.attrs ?? {}), ...(node.props ?? {}), ...(node.name ? { name: node.name } : {}) },
          })),
          edges: context.diagramData.edges.map((edge) => ({
            id: edge.id,
            type: edge.type,
            from: edge.from,
            to: edge.to,
          })),
        })
      : executor.execute({ type: 'findByName', params: [query], originalQuestion: query, confidence: 0.6 }, {
          nodes: context.diagramData.nodes.map((node) => ({
            id: node.id,
            type: node.type,
            data: { ...(node.attrs ?? {}), ...(node.props ?? {}), ...(node.name ? { name: node.name } : {}) },
          })),
          edges: context.diagramData.edges.map((edge) => ({
            id: edge.id,
            type: edge.type,
            from: edge.from,
            to: edge.to,
          })),
        });

    context.stores.highlight.setHighlightedIds(new Set(result.nodeIds));

    return {
      success: result.success,
      summary: result.message,
      data: { nodeIds: result.nodeIds },
    };
  },
};
